<template>
  <div>
  
  
<div>
 <h4 slot="header" class="card-title" style="font-weight:bold;">
     Change Password
    </h4>
</div>
  
 <card class="form-horizontal">
   
   
    <div class="row" style="text-align:left;">
      <label class="col-sm-2 col-form-label">Current Password</label>
      <div class="col-sm-7">
        <fg-input 
                 name="current_password"
                 v-validate="'required'" 
                  type="password" 
                  :error="getError('current_password')"
                  v-model="model.current_password">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>
    

    <div class="row" style="text-align:left;">
      <label class="col-sm-2 col-form-label">New Password</label>
      <div class="col-sm-7">
        <fg-input 
                  name="new_password"
                 v-validate="'required'" 
                  
                  type="password" 
                  :error="getError('new_password')"
                   ref="new_password"
                  v-model="model.new_password">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>

    <div class="row">
      <label class="col-sm-2 col-form-label">Confirm Password</label>
      <div class="col-sm-7">
        <fg-input 
                  name="confirm_password"
                   v-validate="'required|confirmed:new_password'" 
                	type="password"  
                	data-vv-as="new_password"
                  :error="getError('confirm_password')"
                  v-model="model.confirm_password">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    


  </card>
 <div slot="footer" class="text-center">
      <p-button type="info" @click.prevent="editPassword">Change Password</p-button>
    </div>
   
   
   
 


  </div>
</template>
<script>
  import {DatePicker, TimeSelect, Slider, Tag, Input, Button, Select, Option} from 'element-ui'
  import {Collapse, CollapseItem, Tabs, TabPane, Card} from 'src/components/UIComponents'
  import ApiService from 'src/services/api.service'
  import swal from 'sweetalert2'
  
  
  
  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [TimeSelect.name]: TimeSelect,
      [Slider.name]: Slider,
      [Tag.name]: Tag,
      [Input.name]: Input,
      [Button.name]: Button,
      [Option.name]: Option,
      [Select.name]: Select,
      TabPane,
      Tabs,
      CollapseItem,
      Collapse,
      Card
    },
    
     mounted() {
     
     
     		this.createForm = false;
     		
     		let uri = this.$base_url+'/api/v1/entities/get/me';
   
			 ApiService.get(uri).then(response => {
				
				if(response.data.me){
					this.model = response.data.me;
					
			    }
			    if(response.data.org){
			    	this.org = response.data.org;
			    }
			
			})

    },
    
     
    data () {
      return {
        coy:[],
    	eid: this.$route.params.eid,
    	oid: this.$route.params.oid,
    	createForm: true,
    	displayCompanyForm: false,
    	org:{
    	  company_name:'',
          company_uen:'',
          address_1:'',
    	  office_num:'',
    	
    	},
        model: {
         


        },
        modelValidations: {
          confirm_password: {
            //required: true,
            //confirmed:new_password
          },
          new_password: {
            required: true,
          },
          
        },
        
        selects: {
          gov_id_type: [
            {value: 1, label: 'Government ID'},
            {value: 2, label: 'Passport'},
		   ],
		  is_company:[
            {value: 1, label: 'Yes'},
            {value: 2, label: 'No'},
		   ] 
        },
      }
    },
    methods:{
    	onIsCompanyRepChange(event){
       		if(this.model.is_company == 1){

       			this.displayCompanyForm = true;
       		}
       		else{
       			this.displayCompanyForm = false;
       		}
       
       },
       createEntity: function () {
       
       },
       getError(fieldName) {
        return this.errors.first(fieldName)
      },
      submitNewPersonForm() {
        this.$validator.validateAll().then(isValid => {
          if (!isValid) {
    		
  		  } else {
    		let uri = this.$base_url+'/api/v1/entities/create_person';
      		ApiService.post(uri, this.model).then(response => {
      	
         			this.$router.push( '/cs_dashboard')
         		
     		 })
  		  }
        
         
        })
      },///end validate+create
      editPassword() {
        this.$validator.validateAll().then(isValid => {
          if (!isValid) {
    		
  		  } else {
  		     const vm = this;
    		let uri = this.$base_url+'/api/v1/auth/edit/password';
      		ApiService.post(uri, this.model).then(response => {
      				if(response.data.success == 0){
						swal({
							  title: 'Oops!',
							  text: response.data.error,
							  type: 'error',
							  confirmButtonClass: 'btn btn-success btn-fill',
							  buttonsStyling: false
						})
							
					}
					else if(response.data.success == 1){
						swal({
						  title: 'Done!',
						  text: 'Your password has been changed successfully.',
						  type: 'success',
						  confirmButtonClass: 'btn btn-success btn-fill',
						  buttonsStyling: false
						}).then(function(){
			
							vm.$router.push( '/cs_dashboard')
				
						})
					      	 	
      	 				
      	 			}
         		
     		 })
  		  }//end if-else isValid
        
         
        })
      },///end validate+edit

      
      
    },

    
  }
</script>
<style>
  .extended-forms .el-select {
    width: 100%;
  }
  
  .el-date-editor .el-input__inner{
  	padding-left:36px!important;
  }
</style>


